module.exports = __webpack_public_path__ + "assets/alert_circles_light.png";